import StudyingPage from "./StudyingPage";

export default StudyingPage;